module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "pricing-agreements-toolbar"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle pricing-agreements-toolbar__title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('pricingAgreements.titleWithCount', {
    count: _vm.pagination.totalCount
  })))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pricing-agreement-options"
  }, [_c('div', {
    staticClass: "pricing-agreement-options__group pricing-agreement-options__view"
  }, [_c('el-button-group', {
    staticClass: "client-view-type pricing-agreement-options__view-toggle"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pricing-agreement-options__divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-agreement-options__group pricing-agreement-options__filters"
  }, [_c('v-text', {
    staticClass: "searchForm pricing-agreement-options__search",
    attrs: {
      "name": "searchQuery",
      "type": "text",
      "translation": "search.title",
      "value": _vm.searchQuery,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pricing-agreement-options__sort-wrap"
  }, [_c('label', {
    staticClass: "pricing-agreement-options__sort-label"
  }, [_vm._v(_vm._s(_vm.$t('sort.title')))]), _vm._v(" "), _c('v-select', {
    staticClass: "sort pricing-agreement-options__sort",
    attrs: {
      "name": "sort",
      "options": _vm.sortTypes,
      "value": _vm.sort
    },
    on: {
      "change": _vm.onChangeSort
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pricing-agreement-options__divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-agreement-options__group pricing-agreement-options__actions"
  }, [_c('el-button', {
    staticClass: "pricing-agreement-options__import",
    on: {
      "click": function($event) {
        _vm.showImportDialog = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('pricingAgreements.importFromTemplate')) + "\n            ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.create'
      }
    }
  }, [_c('el-button', {
    staticClass: "pricing-agreement-options__new",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('pricingAgreements.newAgreement')))])], 1)], 1)])])], 1)], 1), _vm._v(" "), (_vm.info === 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.sortedFilteredItems.length === 0) ? _c('v-no-data', [(_vm.items.length === 0) ? [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreements')))] : [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreementsMatchSearch')))], _vm._v(" "), (_vm.items.length === 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v(_vm._s(_vm.$t('pricingAgreements.createOne')))])], 1) : _vm._e(), _vm._v(" "), (_vm.items.length === 0) ? [_vm._v(" " + _vm._s(_vm.$t('pricingAgreements.orImportLink')) + " "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showImportDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.importFromTemplateLink')))]), _vm._v(".")] : _vm._e()], 2) : _vm._l((_vm.paginatedItems), function(a, i) {
    return _c('v-card', {
      key: a.id || i,
      nativeOn: {
        "click": function($event) {
          return _vm.goToEdit(a)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel w-full"
    }, [_c('span', {
      class: ['cardBadge', (a.is_active === true) ? 'card-green' : 'card-red']
    }, [_vm._v(_vm._s((a.is_active === true) ? _vm.$t('pricingAgreements.active') : _vm.$t('pricingAgreements.inactive')))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "fa fa-external-link",
      staticStyle: {
        "cursor": "pointer",
        "margin-right": "8px"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editInNewTab(a)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o",
      class: {
        'loading': _vm.deletingId === a.id
      },
      staticStyle: {
        "cursor": "pointer",
        "color": "#f56c6c"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAgreement(a)
        }
      }
    })])]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.customer')) + ": ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(a.client && a.client.name ? a.client.name : '–'))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.valid')) + ": ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(a.valid_from) + " – " + _vm._s(a.valid_to))])]), _vm._v(" "), (a.lines && a.lines.length) ? _c('div', {
      staticClass: "cardinnerBox",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.lineCount', {
      n: a.lines.length
    })))])]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary === 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : (_vm.sortedFilteredItems.length === 0) ? _c('v-no-data', [(_vm.items.length === 0) ? [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreements')))] : [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreementsMatchSearch')))], _vm._v(" "), (_vm.items.length === 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.create'
      }
    }
  }, [_vm._v("\n         "), _c('el-button', [_vm._v(_vm._s(_vm.$t('pricingAgreements.createOne')))])], 1) : _vm._e()], 2) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.paginatedItems
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.name'),
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.goToEdit(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1477792497)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.customer'),
      "prop": "client.name",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.client && scope.row.client.name ? scope.row.client.name : '–'))]
      }
    }], null, false, 894730354)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validFrom'),
      "prop": "valid_from",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validTo'),
      "prop": "valid_to",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('layouts.sidebar.active'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: [(scope.row.is_active === true) ? 'card-green' : 'card-red'],
          staticStyle: {
            "padding": "2px 8px",
            "border-radius": "4px"
          }
        }, [_vm._v("\n            " + _vm._s((scope.row.is_active === true) ? _vm.$t('pricingAgreements.active') : _vm.$t('pricingAgreements.inactive')) + "\n          ")])]
      }
    }], null, false, 1883203708)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.lines'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.lines && scope.row.lines.length) || 0))]
      }
    }], null, false, 1685027486)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.actions'),
      "width": "100",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "fa fa-external-link",
          staticStyle: {
            "cursor": "pointer",
            "margin-right": "8px"
          },
          attrs: {
            "aria-hidden": "true",
            "title": _vm.$t('pricingAgreements.editPricingAgreement')
          },
          on: {
            "click": function($event) {
              return _vm.editInNewTab(scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "fa fa-trash-o",
          class: {
            'loading': _vm.deletingId === scope.row.id
          },
          staticStyle: {
            "cursor": "pointer",
            "color": "#f56c6c"
          },
          attrs: {
            "aria-hidden": "true",
            "title": _vm.$t('button.delete')
          },
          on: {
            "click": function($event) {
              return _vm.deleteAgreement(scope.row)
            }
          }
        })]
      }
    }], null, false, 1877725916)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sortedFilteredItems.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.pagination,
      "switchFunction": _vm.onPageChange
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.hasUnmatched ? _vm.$t('pricingAgreements.unmatchedTitle') : _vm.$t('pricingAgreements.importFromTemplate'),
      "visible": _vm.showImportDialog,
      "width": _vm.hasUnmatched ? '920px' : '500px',
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showImportDialog = $event
      }
    }
  }, [(_vm.hasUnmatched) ? [_c('p', {
    staticClass: "unmatched-intro",
    staticStyle: {
      "margin-bottom": "12px",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.unmatchedIntro')))]), _vm._v(" "), _c('el-table', {
    staticClass: "unmatched-table",
    attrs: {
      "data": _vm.paginatedUnmatchedRows,
      "border": "",
      "stripe": "",
      "row-style": function () { return ({
        background: '#fffbe6'
      }); }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.product'),
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": "",
            "remote": "",
            "placeholder": _vm.$t('pricingAgreements.searchProductByName'),
            "remote-method": function (q) { return _vm.remoteProductSearchForUnmatched(q, scope.row); },
            "loading": _vm.unmatchedSelections[scope.row.row_index] && _vm.unmatchedSelections[scope.row.row_index].loading,
            "clearable": ""
          },
          on: {
            "focus": function($event) {
              _vm.ensureUnmatchedSelection(scope.row).productOptions.length === 0 && _vm.remoteProductSearchForUnmatched('', scope.row)
            }
          },
          model: {
            value: (_vm.unmatchedSelections[scope.row.row_index].productId),
            callback: function($$v) {
              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "productId", $$v)
            },
            expression: "unmatchedSelections[scope.row.row_index].productId"
          }
        }, _vm._l(((_vm.unmatchedSelections[scope.row.row_index] && _vm.unmatchedSelections[scope.row.row_index].productOptions) || []), function(p) {
          return _c('el-option', {
            key: p.id,
            attrs: {
              "label": p.number ? p.name + ' (' + p.number + ')' : p.name,
              "value": p.id
            }
          })
        }), 1)]
      }
    }], null, false, 1766926496)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.importedName'),
      "min-width": "200",
      "prop": "product_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.discountPercent'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "type": "number",
            "placeholder": "%",
            "size": "small",
            "min": "0",
            "max": "100"
          },
          model: {
            value: (_vm.unmatchedSelections[scope.row.row_index].discountPercent),
            callback: function($$v) {
              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "discountPercent", _vm._n($$v))
            },
            expression: "unmatchedSelections[scope.row.row_index].discountPercent"
          }
        })]
      }
    }], null, false, 879113495)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('pricingAgreements.discountAmount'),
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "type": "number",
            "placeholder": _vm.$t('pricingAgreements.perUnit'),
            "size": "small",
            "min": "0"
          },
          model: {
            value: (_vm.unmatchedSelections[scope.row.row_index].discountAmount),
            callback: function($$v) {
              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "discountAmount", _vm._n($$v))
            },
            expression: "unmatchedSelections[scope.row.row_index].discountAmount"
          }
        })]
      }
    }], null, false, 2163540884)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.addUnmatchedLine(scope.row)
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t('pricingAgreements.addLine')) + "\n            ")])]
      }
    }], null, false, 1632589546)
  })], 1), _vm._v(" "), (_vm.unmatchedPagination.lastPage > 1) ? _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.unmatchedPagination.currentPage,
      "page-size": _vm.unmatchedPagination.limit,
      "total": _vm.unmatchedPagination.totalCount,
      "layout": "total, prev, pager, next"
    },
    on: {
      "current-change": _vm.onUnmatchedPageChange
    }
  })], 1) : _vm._e()] : [_c('p', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.templateDownloadUrl,
      "download": "pricing-agreement-template.xlsx",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pricingAgreements.downloadTemplate')) + "\n        ")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.customer'),
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.selectCustomer'),
      "filterable": ""
    },
    model: {
      value: (_vm.importForm.client_id),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "client_id", $$v)
      },
      expression: "importForm.client_id"
    }
  }, _vm._l((_vm.clients), function(c) {
    return _c('el-option', {
      key: c.id,
      attrs: {
        "label": c.name,
        "value": c.id,
        "disabled": c.system_generated === 1
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.agreementName')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.agreementNamePlaceholder')
    },
    model: {
      value: (_vm.importForm.name),
      callback: function($$v) {
        _vm.$set(_vm.importForm, "name", $$v)
      },
      expression: "importForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.file'),
      "required": ""
    }
  }, [_c('el-upload', {
    ref: "importUpload",
    attrs: {
      "auto-upload": false,
      "limit": 1,
      "on-change": _vm.onImportFileChange,
      "on-remove": _vm.onImportFileRemove,
      "accept": ".csv,.txt,.xlsx,.xls"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.chooseFile')))])], 1)], 1)], 1)], _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "10px",
      "justify-content": "flex-end",
      "align-items": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.hasUnmatched) ? [_c('el-button', {
    on: {
      "click": _vm.closeUnmatchedAndGoToEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.closeAndViewAgreement')))])] : [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showImportDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.doImport
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.import')))])]], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07847f80","hasScoped":true}!./src/app/pages/withNavigation/pricingAgreements/index/index.html
// module id = 2901
// module chunks = 1